import React, { useState } from 'react'
import TRANSLATE from 'utils/constants'
import FilterListIcon from '@material-ui/icons/FilterList'
import {
   Button,
   Popper,
   List,
   ListItem,
   Typography,
   ListItemIcon,
   ListItemText,
   Checkbox,
   Grid,
   makeStyles
} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
   listWithAction: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: 'white'
   },
   popperContainer: {
      boxShadow:
         '0px 0px 5px rgba(63, 63, 68, 0.4), 0px 1px 3px rgba(63, 63, 68, 0.4)',
      borderRadius: '4px',
      zIndex: '1201'
   },
   popperWindowLayout: {
      padding: theme.spacing(0, 1),
      backgroundColor: theme.palette.background.paper,
      minWidth: '250px',
      borderRadius: '4px'
   },
   popperButton: {
      backgroundColor: 'rgb(232,245,255)',
      borderRadius: '20px',
      border: 'none',
      padding: '5px 10px'
   },
   listContainer: {
      overflowY: 'auto',
      maxHeight: '208px'
   },
   listItem: {
      borderBottom: '1px solid rgba(224, 224, 224, 0.5)'
   },
   title: {
      fontWeight: '500',
      fontSize: '16px',
      color: '#3A3B3F',
      padding: theme.spacing(2)
   },
   buttonContainer: {
      padding: theme.spacing(2, 0)
   },
   applyButton: {
      backgroundColor: '#12B3F9',
      color: '#DFEAFF',
      padding: '1px 12px'
   },
   cancelButton: {
      color: '#12B3F9',
      padding: '1px 12px'
   }
}))

const ItemsListWithPrimaryAction = ({
   availableItemsListToApply,
   selectedItems,
   setSelectedItems
}) => {
   const classes = useStyles()

   const handleToggle = value => () => {
      const currentIndex = selectedItems.map(item => item.id).indexOf(value.id)
      const newSelectedItems = [...selectedItems]
      if (currentIndex === -1) {
         newSelectedItems.push(value)
      } else {
         newSelectedItems.splice(currentIndex, 1)
      }
      setSelectedItems(newSelectedItems)
   }

   return (
      <List className={classes.listWithAction}>
         {availableItemsListToApply.map(value => {
            const labelId = value.id
            return (
               <ListItem
                  key={value.id}
                  role={undefined}
                  dense
                  button
                  onClick={handleToggle(value)}
                  className={classes.listItem}
               >
                  <ListItemIcon>
                     <Checkbox
                        edge="start"
                        checked={
                           selectedItems
                              .map(item => item.id)
                              .indexOf(value.id) !== -1
                        }
                        tabIndex={-1}
                        disableRipple
                        inputProps={{ 'aria-labelledby': labelId }}
                        color="primary"
                     />
                  </ListItemIcon>
                  <ListItemText id={labelId} primary={value.name} />
               </ListItem>
            )
         })}
      </List>
   )
}

const PopperWindowLayout = ({
   rowData,
   availableItemsListToApply,
   onApplyItemsToRowCallback,
   currentRowIdToApplyItems,
   popperWindowTitle,
   cancelCallback,
   previousAppliedItemsList
}) => {
   const [selectedItems, setSelectedItems] = useState(
      previousAppliedItemsList || []
   )
   const classes = useStyles()

   const onApplyItemsToRow = evt => {
      onApplyItemsToRowCallback(currentRowIdToApplyItems, selectedItems, rowData)
      cancelCallback(evt)
   }

   const handleSelectAll = () =>
      setSelectedItems([...availableItemsListToApply])

   return (
      <Grid className={classes.popperWindowLayout}>
         <Grid container justify="space-between">
            <Typography className={classes.title}>
               {popperWindowTitle || TRANSLATE.LABELS.ASSIGNED_ROLES}
            </Typography>
            <div
               style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
               }}
            >
               <Button
                  className={classes.cancelButton}
                  color="primary"
                  size="small"
                  onClick={handleSelectAll}
               >
                  Selecionar todos
               </Button>
            </div>
         </Grid>

         <Grid className={classes.listContainer}>
            <ItemsListWithPrimaryAction
               availableItemsListToApply={availableItemsListToApply}
               selectedItems={selectedItems}
               setSelectedItems={setSelectedItems}
            />
         </Grid>
         <Grid
            container
            justifyContent="space-evenly"
            className={classes.buttonContainer}
         >
            <Button className={classes.cancelButton} onClick={cancelCallback}>
               {TRANSLATE.BUTTONS.CANCEL}
            </Button>
            <Button className={classes.applyButton} onClick={onApplyItemsToRow}>
               {TRANSLATE.BUTTONS.APPLY}
            </Button>
         </Grid>
      </Grid>
   )
}

const SelectAndApply = ({
   rowData,
   currentRowIdToApplyItems,
   previousAppliedItemsList,
   availableItemsListToApply,
   onApplyItemsToRowCallback,
   popperButtonText = TRANSLATE.BUTTONS.ROLES,
   popperWindowTitle
}) => {
   const classes = useStyles()
   const [anchorEl, setAnchorEl] = useState(null)
   const isOpen = Boolean(anchorEl)
   const id = isOpen ? 'simple-popper' : undefined

   const handleToggleOpen = event => {
      setAnchorEl(anchorEl ? null : event.currentTarget)
   }

   return (
      <Grid>
         <Button
            className={classes.popperButton}
            aria-describedby={id}
            onClick={handleToggleOpen}
            endIcon={<FilterListIcon fontSize="small" />}
         >
            {popperButtonText}
         </Button>
         <Popper
            id={id}
            open={isOpen}
            anchorEl={anchorEl}
            className={classes.popperContainer}
         >
            <PopperWindowLayout
               rowData={rowData}
               currentRowIdToApplyItems={currentRowIdToApplyItems}
               availableItemsListToApply={availableItemsListToApply}
               previousAppliedItemsList={previousAppliedItemsList}
               onApplyItemsToRowCallback={onApplyItemsToRowCallback}
               popperWindowTitle={popperWindowTitle}
               cancelCallback={handleToggleOpen}
            />
         </Popper>
      </Grid>
   )
}

export default SelectAndApply
